import React, { Component, Fragment } from 'react';
import { Translation } from 'react-i18next';
import SVGElements from 'root/components/SVGElements';
import moment from 'moment';
import { MdClose } from 'react-icons/md';
import { zeroPad } from 'react-countdown-now';

class MaintenanceModalV2 extends Component {
  isMount = true;
  constructor(props) {
    super(props);
    this.controls = {};
    this.state = {
      isloading: false,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      isShowMaintenanceModal: false,
      formattedStartDate: '',
      formattedEndDate: '',
      formattedStartTime: '',
      formattedEndTime: '',
    };
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
    this.processMaintenanceDetails();
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  processMaintenanceDetails() {
    const { maintenanceDetails } = this.props;

    const startTime = Date.parse(maintenanceDetails.startTime);
    const endTime = new Date(maintenanceDetails.endTime);

    let formattedStartDate = '';
    let formattedStartTime = '';
    let formattedEndDate = '';
    let formattedEndTime = '';

    if (maintenanceDetails) {
      formattedStartDate = moment(startTime).format('DD/MM/YYYY');
      formattedStartTime = moment(startTime).format('HH:mm:ss');
      formattedEndDate = moment(endTime).format('DD/MM/YYYY');
      formattedEndTime = moment(endTime).format('HH:mm:ss');

      this.setState({
        formattedStartDate,
        formattedEndDate,
        formattedStartTime,
        formattedEndTime
      })
    }

  }

  tick = () => {
    const { maintenanceDetails } = this.props;
    let time = new Date(maintenanceDetails.endTime) - Date.now();
    let dayTime = 24 * 60 * 60 * 1000;
    let days = Math.max(Math.floor(time / dayTime), 0);
    let hourTime = time % dayTime;
    let hours = Math.max(Math.floor(hourTime / (60 * 60 * 1000)), 0);
    let minTime = hourTime % (60 * 60 * 1000);
    let mins = Math.max(Math.floor(minTime / (60 * 1000)), 0);
    let secs = Math.max(Math.floor((time % (1000 * 60)) / 1000), 0);

    this.setState({
      currentTime: new Date(),
      days: days,
      hours: hours,
      minutes: mins,
      seconds: secs,
    });
  }

  render() {
    const { handleClose, providerName } = this.props;

    return (
      <Translation>
        {(t) => (
          <div className='maintenancePopup-Box'>
            <div className='box'>
              <div className='box-header'>
                <div className='box-header-right'>
                  <MdClose onClick={handleClose} />
                </div>
              </div>
              <div className='box-body'>
                <div className='maintenance-icon'>
                  <img src='/public/html/images/icon/maintenance-icon.svg' />
                </div>
                <div className='maintenance-title'>
                  {providerName + ' ' + t('global:global.messages.maintenance.underMaintenance', 'Under Maintenance')}
                </div>
                <div className='maintenance-details'>
                  <div className='maintenance-date-container'>
                    <div className='maintenance-container'>
                      <div className="maintenance-container-column1">
                        <span className='key'>{t('global:global.messages.maintenance.startFrom', 'Start From')}</span>
                      </div>
                      <div className='dateColon'><span>:</span></div>
                      <div className="maintenance-container-column2">
                        <span className='dateTime'>{this.state.formattedStartDate}</span>
                        <span className='slashColor'> - </span>
                        <span className='dateTime'>{this.state.formattedStartTime}</span>
                      </div>
                    </div>
                    {this.state.untilFurtherNotice ?
                      <div className='further-notice-container maintenance-container'>
                        <div className="maintenance-container-column1">
                          <span className='key'>{t('global:global.messages.maintenance.estimatedEndTime', 'Estimated End Time')}</span>
                        </div>
                        <div className="maintenance-container-column2">
                          <span> {this.state.formattedStartDate} : {this.state.formattedStartTime} </span>
                          <span className='dateTime'>{t('global:global.messages.maintenance.untilFurtherNotice', 'Until further notice')}</span>
                        </div>
                      </div>
                      :
                      <div className='maintenance-container'>
                        <div className="maintenance-container-column1">
                          <span className='key'>{t('global:global.messages.maintenance.estimatedEndTime', 'Estimated End Time')}</span>
                        </div>
                        <div className='dateColon'><span>:</span></div>
                        <div className="maintenance-container-column2">
                          <span className='dateTime'>{this.state.formattedEndDate}</span>
                          <span className='slashColor'> - </span>
                          <span className='dateTime'>{this.state.formattedEndTime}</span>
                        </div>
                      </div>
                    }
                  </div>
                  <div className='maintenance-timer-container'>
                    <div className='timer-container row1'>
                      <span className='timer'>{zeroPad(this.state.days)}</span>
                      <span className='timer'>{zeroPad(this.state.hours)}</span>
                      <span className='timer'>{zeroPad(this.state.minutes)}</span>
                      <span className='timer'>{zeroPad(this.state.seconds)}</span>
                    </div>
                    <div className='timer-container row2'>
                      <span className='timer-status'>{t('global:global.messages.maintenance.day', 'Days')}</span>
                      <span className='timer-status'>{t('global:global.messages.maintenance.hour', 'hours')}</span>
                      <span className='timer-status'>{t('global:global.messages.maintenance.minute', 'minute')}</span>
                      <span className='timer-status'>{t('global:global.messages.maintenance.second', 'second')}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='box-overlay' onClick={handleClose}></div>
          </div>
        )}
      </Translation>
    );
  }
}

export default MaintenanceModalV2;
